import * as angular from 'angular';
import * as _ from 'lodash-es';
import AppConstants from '../gorillaboy/AppConstants';
import {FeatureNotificationResponse, FeatureNotification} from './FeatureNotificationTypes'

interface FeatureNotificationService {
    getNotificationsPeriod: () => ng.IPromise<FeatureNotificationResponse>;
    acknowledgeFeature: (featureName: string) => void;
    cleanAcknowledgedFeatureIfExists: (featureName: string) => void;
    isValidNotification: (featureName: string, featureNotificationList: FeatureNotification[]) => boolean;
}
FeatureNotificationServiceFactory.$inject = ['localStorageService', 'RegionService', 'EndpointConfig', '$http', '$log', '$q'];
function FeatureNotificationServiceFactory(localStorageService:any, RegionService:any, EndpointConfig:any, $http:ng.IHttpService, $log:ng.ILogService, $q:ng.IQService) {

    let FEATURE_NOTIFICATION = "feature_notification";
    let FEATURE_NOTIFICATION_FILE = "feature-notification-info";

    let service : FeatureNotificationService = {

        getNotificationsPeriod: function() {
            var region = RegionService.getRegion(),
                stage = region ? EndpointConfig.stage(region) : null;

            var fileSuffix = (stage === 'ALPHA' || stage === 'DEV')? '_ALPHA'
                            : (stage === 'GAMMA')? "_GAMMA"
                            : EndpointConfig.isPreviewSite()? "_PREVIEW"
                            : "";

            var featureNotficationJsonURL = AppConstants.FEATURE_NOTIFICATION_PERIOD_BUCKET
                                             + FEATURE_NOTIFICATION_FILE + fileSuffix + ".json";

            var promise:ng.IPromise<FeatureNotificationResponse> = $http.get(featureNotficationJsonURL)
            .then((response) => {
              var data:any = response.data;
              if (data && data.featureNotificationList) {

                  return data as FeatureNotificationResponse;
              }
              return {
                  featureNotificationList: []
              } as FeatureNotificationResponse;
            });

            return promise;
        },

        acknowledgeFeature: function(featureName) {

            var ackFeatures = localStorageService.get(FEATURE_NOTIFICATION);
            if(ackFeatures) {

                // If feature is already in local storage, don't push it again.
                // Avoid duplicates
                var ackFeaturesIdx = ackFeatures.indexOf(featureName);
                if (ackFeaturesIdx < 0) {
                    ackFeatures.push(featureName);
                    localStorageService.set(FEATURE_NOTIFICATION, ackFeatures);
                }

            } else {
                var features = [];
                features.push(featureName);
                localStorageService.set(FEATURE_NOTIFICATION, features);
            }
        },

        cleanAcknowledgedFeatureIfExists: function(featureName) {
            var ackFeatures = localStorageService.get(FEATURE_NOTIFICATION);
            if (ackFeatures) {
                var ackFeaturesIdx = ackFeatures.indexOf(featureName);
                if (ackFeaturesIdx >= 0){
                    ackFeatures.splice(ackFeaturesIdx, 1);
                    localStorageService.set(FEATURE_NOTIFICATION, ackFeatures);
                }
            }
        },

        isValidNotification: function(featureName, featureNotificationList: FeatureNotification[]) {

            //Check if notification is in period
            var notificationPeriodIdx = _.findIndex(featureNotificationList, function(n:FeatureNotification){
                return n.featureName == featureName;
            });

            // Notification is not defined in JSON file
            if(notificationPeriodIdx < 0) {
                $log.info("Feature notification not found in JSON: " + featureName);
                this.cleanAcknowledgedFeatureIfExists(featureName);
                return false;
            }

            // There isn't a period of time for notification
            var notificationPeriod = featureNotificationList[notificationPeriodIdx];
            if (!notificationPeriod.startNotificationTime || !notificationPeriod.endNotificationTime){
                $log.info("Feature notification doesn't have defined time range: " + featureName);
                this.cleanAcknowledgedFeatureIfExists(featureName);
                return false;
            }

            var currentMillisTime = Date.now();
            if (notificationPeriod.endNotificationTime < currentMillisTime) {
                $log.info("Feature notification period has already passed: " + featureName)
                this.cleanAcknowledgedFeatureIfExists(featureName);
                return false;
            }

            var isFeatureAcknowledged = false;
            var ackFeatures = localStorageService.get(FEATURE_NOTIFICATION);
            if (ackFeatures) {
                isFeatureAcknowledged = ackFeatures.indexOf(featureName) >= 0;
            }

            return notificationPeriod.startNotificationTime <= currentMillisTime &&
                !isFeatureAcknowledged;
        }
    };

    return service;
}

angular.module('GorillaBoy.services')
    .factory('FeatureNotificationService', FeatureNotificationServiceFactory);

export{
    FeatureNotificationService
}
